module.exports = __webpack_public_path__ + "assets/961f95a209e067d01e02e49b135e105d.png";